import { render, staticRenderFns } from "./ModalSinistro.vue?vue&type=template&id=1cfa01d5&"
import script from "./ModalSinistro.vue?vue&type=script&lang=js&"
export * from "./ModalSinistro.vue?vue&type=script&lang=js&"
import style0 from "./ModalSinistro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports